import React from 'react';
import { useGetLiveSessionQuery } from '../../../../generated/core-api/graphql-react-query';
import useSessionStoreContext from '../Contexts/SessionStoreContextProvider/useSessionStoreContext';

export default function useSessionInfo() {
  const { sessionId: [sessionId] } = useSessionStoreContext();
  const session = useGetLiveSessionQuery({ input: { id: sessionId ?? '' } }, { enabled: !!sessionId });

  const value = React.useMemo(() => session.data?.getSession, [session.data?.getSession]);
  return value;
}
